export const DISTANCES = {
  0: 3000 * 1000,
  1: 2500 * 1000,
  2: 1500 * 1000,
  3: 750 * 1000,
  4: 500 * 1000,
  5: 250 * 1000,
  6: 120 * 1000,
  7: 70 * 1000,
  8: 35 * 1000,
  9: 20 * 1000,
  10: 10000,
  11: 7500,
  12: 3000,
  13: 1000,
  14: 750,
  15: 600,
  16: 300,
  17: 50,
  18: 30,
  19: 0,
};
